export const translations = {
  en: {
    // Landing
    hero_title: 'Answer customers on WhatsApp — automatically.',
    hero_subtitle:
      'Your AI assistant that answers customer questions on WhatsApp 24/7, so you never miss a message.',
    hero_cta: 'Start free — No credit card',
    hero_badge1: 'Setup in under 2 minutes',
    hero_badge2: 'Works with any WhatsApp number',
    hero_badge3: 'No technical skills required',
    sign_in: 'Sign In',
    get_started: 'Get Started',

    // Nav
    features: 'Features',
    pricing: 'Pricing',
    faq: 'FAQ',

    // Dashboard sidebar
    panel: 'Dashboard',
    whatsapp: 'WhatsApp',
    ai_config: 'AI Configuration',
    conversations: 'Conversations',
    appointments: 'Appointments',
    products: 'Products',
    campaigns: 'Campaigns',
    media: 'Media',
    plans: 'Plans',
    analytics: 'Analytics',
    logout: 'Log Out',

    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    loading: 'Loading...',
    upgrade: 'Upgrade',
  },
  es: {
    hero_title: 'Responde a tus clientes en WhatsApp — automáticamente.',
    hero_subtitle:
      'Tu asistente de IA que responde las preguntas de tus clientes en WhatsApp 24/7, para que no pierdas ningún mensaje.',
    hero_cta: 'Empieza gratis — Sin tarjeta de crédito',
    hero_badge1: 'Configura en menos de 2 minutos',
    hero_badge2: 'Funciona con cualquier número de WhatsApp',
    hero_badge3: 'No necesitas conocimientos técnicos',
    sign_in: 'Iniciar Sesión',
    get_started: 'Comenzar',

    features: 'Funciones',
    pricing: 'Precios',
    faq: 'Preguntas Frecuentes',

    panel: 'Panel',
    whatsapp: 'WhatsApp',
    ai_config: 'Configuración IA',
    conversations: 'Conversaciones',
    appointments: 'Citas',
    products: 'Productos',
    campaigns: 'Campañas',
    media: 'Medios',
    plans: 'Planes',
    analytics: 'Analíticas',
    logout: 'Cerrar Sesión',

    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    add: 'Agregar',
    search: 'Buscar',
    loading: 'Cargando...',
    upgrade: 'Mejorar Plan',
  }
};
